import { useSite } from "@/lib/SiteContext";
import { useT } from "@/lib/i18n";
import Reveal from "./Reveal";

export const Proceso = () => {
  const { locale } = useSite();
  const { t } = useT(locale);
  const steps = t("proceso.steps");

  return (
    <section
      id="proceso"
      className="relative py-28 md:py-36 overflow-hidden"
      style={{ backgroundColor: "var(--ix-night)", color: "var(--ix-cream)" }}
      data-testid="proceso-section"
    >
      <div className="max-w-[1480px] mx-auto px-5 md:px-10 lg:px-14">
        <Reveal>
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 mb-16">
            <div className="lg:col-span-4">
              <div className="ix-mono text-[0.7rem] uppercase tracking-[0.18em] flex items-center gap-2">
                <span className="ix-grad-text font-semibold">◆</span>
                {t("proceso.eyebrow")}
              </div>
            </div>
            <div className="lg:col-span-8">
              <h2 className="ix-display ix-headline-lg text-[var(--ix-cream)]">
                {t("proceso.title")}
              </h2>
            </div>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {steps.map((s, i) => (
            <Reveal
              as="div"
              key={s.n}
              delay={i * 90}
              className="ix-card p-6 md:p-7 relative ix-sweep flex flex-col h-full"
              data-testid={`proceso-step-${s.n}`}
            >
              <div className="mb-7">
                <div
                  aria-hidden
                  style={{
                    width: 22, height: 28,
                    background: ["linear-gradient(135deg,#FF1F8F,#FCB424)","linear-gradient(135deg,#FCB424,#8AE52E)","linear-gradient(135deg,#8AE52E,#2DD4BF)","linear-gradient(135deg,#FF1F8F,#8AE52E)","linear-gradient(135deg,#FCB424,#FF1F8F)"][i],
                    clipPath: "polygon(22% 0%, 100% 0%, 78% 100%, 0% 100%)",
                  }}
                />
              </div>
              <div className="ix-numeral ix-grad-text leading-none" style={{ fontSize: "clamp(3rem, 7vw, 5rem)" }}>
                {s.n}
              </div>
              <h3 className="ix-display text-[1.2rem] md:text-[1.3rem] mt-5 leading-tight text-[var(--ix-cream)]">
                {s.t}
              </h3>
              <p className="mt-3 text-[0.88rem] leading-relaxed text-[var(--ix-cream)]/70 flex-1">
                {s.d}
              </p>
              {/* connector line on desktop */}
              {i < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-[14px] w-7 h-px bg-[var(--ix-cream)]/20" aria-hidden />
              )}
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Proceso;
